import { render, staticRenderFns } from "./edit-user-blocks.vue?vue&type=template&id=2b6bac78&scoped=true&"
import script from "./edit-user-blocks.vue?vue&type=script&lang=js&"
export * from "./edit-user-blocks.vue?vue&type=script&lang=js&"
import style0 from "./edit-user-blocks.vue?vue&type=style&index=0&id=2b6bac78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6bac78",
  null
  
)

export default component.exports